module.exports = __webpack_public_path__ + "img/vendor-icon-caterers.85527076.png";